export const activeTab = state => state.activeTab;
export const list = state => state.commentList;
export const activeComment = state => state.activeComment;



// WEBPACK FOOTER //
// ./src/screens/Class/Details/Comments/store/getters.js